export class InfoInListGoods
{
    countShipment: number;
    sumWeight: number;
    sumCalWeight: number;
    sumTotalBox: number;
}